import { OneDataCollection } from '@factorialco/f0-react/dist/experimental'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import {
  TaskFormsDataCollectionDocument,
  type TaskFormItemFragment,
} from 'generated/resources/graphql'

import { useGraphqlDataCollectionSource } from 'modules/core/hooks/useGraphqlDataCollectionSource'
import {
  dateBackendDateTimeToRelativeTime,
  i18nDateToString,
  stringToDate,
} from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

const TaskFormsContent = () => {
  const FORM_CATEGORY_LABELS: Record<string, string> = {
    basic: i18n.t('procurement.purchase_requests.settings.task_forms.form_category_value.basic'),
  }
  const { company } = useCurrentSession()
  const source = useGraphqlDataCollectionSource({
    document: TaskFormsDataCollectionDocument,
    mapData: (data) => data.procurement.taskFormsConnection.edges.map((edge) => edge.node) ?? [],
    mapPagination: (data) => ({
      total: data.procurement.taskFormsConnection.totalCount ?? 0,
    }),
    mapVariables: ({ sortings }) => ({
      companyId: company?.id,
      sortOrder: sortings?.[0],
    }),
  })

  return (
    <>
      <OneDataCollection
        source={source}
        visualizations={[
          {
            type: 'table',
            options: {
              columns: [
                {
                  label: i18n.t('procurement.purchase_requests.settings.task_forms.columns.name'),
                  render: (item: TaskFormItemFragment) => ({
                    type: 'text' as const,
                    value: {
                      text: item.name,
                    },
                  }),
                },
                {
                  label: i18n.t(
                    'procurement.purchase_requests.settings.task_forms.columns.form_category'
                  ),
                  render: (item: TaskFormItemFragment) => ({
                    type: 'text' as const,
                    value: {
                      text: (item.category && FORM_CATEGORY_LABELS[item.category]) ?? '',
                    },
                  }),
                },
                {
                  label: i18n.t(
                    'procurement.purchase_requests.settings.task_forms.columns.created'
                  ),
                  render: (item: TaskFormItemFragment) => ({
                    type: 'text' as const,
                    value: {
                      text: item.createdAt
                        ? i18nDateToString(
                            stringToDate(item.createdAt, 'backend_datetime'),
                            'ui_short'
                          )
                        : '',
                    },
                  }),
                },
                {
                  label: i18n.t(
                    'procurement.purchase_requests.settings.task_forms.columns.last_modified'
                  ),
                  render: (item: TaskFormItemFragment) => ({
                    type: 'text' as const,
                    value: {
                      text: item.updatedAt ? dateBackendDateTimeToRelativeTime(item.updatedAt) : '',
                    },
                  }),
                },
              ],
              frozenColumns: 1 as const,
            },
          },
        ]}
        emptyStates={{
          'no-data': {
            title: i18n.t('procurement.purchase_requests.settings.task_forms.empty_state_title'),
            description: i18n.t(
              'procurement.purchase_requests.settings.task_forms.empty_state_description'
            ),
          },
        }}
      />
    </>
  )
}

export default TaskFormsContent
